import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

Modal.setAppElement('#root');

// Palco escuro, como a câmera do WhatsApp: a imagem ocupa o quadro e o "X" fica no topo.
const customStyles = {
  overlay: {
    backgroundColor: 'rgba(11, 20, 26, 0.85)',
    zIndex: 1400,
  },
  content: {
    width: 'min(780px, calc(100vw - 24px))',
    height: 'min(640px, calc(100vh - 24px))',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: 8,
    boxShadow: '0 16px 55px rgba(0, 0, 0, 0.5)',
    border: 'none',
    padding: 0,
    background: '#0b141a',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

const headerStyle = {
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  height: 52,
  padding: '0 8px',
  background: '#202c33',
  color: '#e9edef',
  fontSize: 16,
  fontWeight: 600,
};

const closeStyle = {
  width: 40,
  height: 40,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 0,
  borderRadius: '50%',
  background: 'transparent',
  color: '#aebac1',
  cursor: 'pointer',
};

const stageStyle = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

const ModalCamera = ({ isOpen, onRequestClose, onCapture }) => {
  const [capturedImage, setCapturedImage] = useState(null);

  const handleTakePhoto = (dataUri) => {
    setCapturedImage(dataUri);
  };

  // Foto tirada: entrega o arquivo e fecha (fora da renderização, para não atualizar estado no meio dela).
  useEffect(() => {
    if (!capturedImage) return;

    // Converta a imagem capturada em um arquivo (Blob)
    fetch(capturedImage)
      .then((res) => res.blob())
      .then((blob) => {
        // Chame a função de retorno com o arquivo da imagem capturada
        onCapture(blob);
      });

    // Feche o modal
    setCapturedImage(null);
    onRequestClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capturedImage]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Tirar foto"
    >
      <div style={headerStyle}>
        <button
          type="button"
          style={closeStyle}
          onClick={onRequestClose}
          aria-label="Fechar câmera"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
        {/* TODO i18n */}
        <span>Tirar foto</span>
      </div>
      <div style={stageStyle}>
        <Camera
          onTakePhoto={handleTakePhoto}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          isImageMirror={false}
        />
      </div>
    </Modal>
  );
};

export default ModalCamera;
